import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  // Padrão: fundo azul escuro + texto branco.
  // Para saídas/estados negativos (variant=destructive ou className com red/rose): texto vermelho escuro.
  const cls = String(className || "");
  const isNegative = variant === "destructive"
    || /\b(bg|text|border)-(red|rose|destructive)[-\s]/i.test(cls)
    || /saida|saída|negativ/i.test(cls);
  const forced = `!bg-blue-900 !border-blue-900 !border !shadow-none ${isNegative ? "!text-red-700" : "!text-white"}`;
  return (<div className={cn(badgeVariants({ variant }), className, forced, isNegative ? "app-badge-neg" : "app-badge")} {...props} />);
}

export { Badge, badgeVariants }
